import { connect } from 'react-redux';

import ExportPanel from './ExportPanel';
import {
  actions as assessmentItemsActions,
  selectors as assessmentItemsSelectors,
} from '$data/assessmentItems';
import {
  actions as assignmentsActions,
  selectors as assignmentsSelectors,
} from '$data/assignments';
import { selectors as coreSelectors } from '$data/core';
import mergeGrades from './utils/mergeGrades';
import filterMappedAssignments from './utils/filterMappedAssignments';
import launchTurnitinAssignment from '$utils/launchTurnitinAssignment';

const createLaunchTurnitinAssignmentFunction = (state) => (assignmentId) => {
  const spaceId = coreSelectors.getCurrentSpace(state).id;
  const user = coreSelectors.getUser(state);
  const assignment = assignmentsSelectors.getAssignmentById(
    state,
    assignmentId
  );

  launchTurnitinAssignment({
    user,
    spaceId,
    assignment,
  });
};

const mapStateToProps = (state) => ({
  assessmentItems: assessmentItemsSelectors.getAssessmentItems(state),
  assignments: assignmentsSelectors.getAssignments(state),
  assignmentGrades: assignmentsSelectors.getGrades(state),
  isInitiatingExport: assessmentItemsSelectors.getIsInitiatingExport(state),
  isGeneratingCsv: assessmentItemsSelectors.getIsGeneratingCsv(state),
  isFetchingGrades:
    assignmentsSelectors.getGradesLoading(state) ||
    assessmentItemsSelectors.getIsFetchingGrades(state),
  fetchGradesError:
    assignmentsSelectors.getGradesError(state) ||
    assessmentItemsSelectors.getFetchGradesError(state),
  hasAwaitingDecision: coreSelectors.getHasAwaitingDecision(state),
  hasGradeOverride: coreSelectors.getHasGradeOverride(state),
  launchTurnitinAssignment: createLaunchTurnitinAssignmentFunction(state),
});

const mapDispatchToProps = {
  fetchGradesForAssignments: assignmentsActions.fetchGradesForAssignments,
  fetchCalculatedGrades: assessmentItemsActions.fetchCalculatedGrades,
  onDownloadCsv: assessmentItemsActions.downloadCsv,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  studentGrades: mergeGrades({
    assignmentGrades: stateProps.assignmentGrades,
    assessmentItems: stateProps.assessmentItems,
    assessmentItemId: ownProps.assessmentItemId,
    hasAwaitingDecision: stateProps.hasAwaitingDecision,
  }),
  mappedAssignments: filterMappedAssignments({
    assessmentItems: stateProps.assessmentItems,
    assignments: stateProps.assignments,
    assessmentItemId: ownProps.assessmentItemId,
  }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ExportPanel);
